import _ from 'lodash';

import APIService from '_app/services/api';
import { generateMapPolygonUpdateFormData } from '_app/utils/converter';

export const fetchProperties = async ({ tab, page = 1 }) => {
  const { data } = await APIService.get(`/properties/${tab}/?page=${page}&limit=50`);
  return { ...data, page };
};

export const fetchPropertyTabCounts = async () => {
  const { data } = await APIService.get('/properties/tab-counts/');
  return data;
};

export const fetchSearchForm = async () => {
  const { data } = await APIService.get('/search-form/');
  return data;
};

export const submitSearchForm = async (formData) => {
  const { data } = await APIService.post('/search-form/', formData);
  return data;
};

export const resetSearchForm = async () => {
  const { data } = await APIService.post('/search-form/', new FormData());
  return data;
};

export const fetchProperty = async (mlsnum) => {
  const { data } = await APIService.get(`/properties/${mlsnum}/`);
  return data;
};

export const rateProperty = async ({ mlsnum, status }) => {
  const formData = new FormData();
  formData.append('mlsnum', mlsnum);

  if (status === 1 || status === -1) {
    formData.append('rating', status);
    const { data } = await APIService.post(`/properties/${mlsnum}/rate/`, formData);
    return data;
  }

  const { data } = await APIService.delete(`/properties/${mlsnum}/rate/`, { data: formData });
  return data;
};

export const addProperty = async ({ mlsnum }) => {
  const formData = new FormData();
  formData.append('mlsnums', mlsnum);

  const { data } = await APIService.post('/properties/manually-add/', formData);
  return data;
};

export const searchManualAdd = async (search) => {
  const { data } = await APIService.get(`/properties/manually-add/?search=${search}`);
  return data?.results || [];
};

export const fetchChat = async (mlsnum = null) => {
  const { data } = await APIService.get('/chat/', { params: mlsnum ? { mlsnum } : null });
  return _.orderBy(data.messages || [], ['datetime'], 'asc');
};

export const sendChat = async ({ message, mlsnum = null }) => {
  const formData = new FormData();
  formData.append('message', message);

  if (mlsnum) {
    formData.append('mlsnum', mlsnum);
  }

  const { data } = await APIService.post('/chat/', formData);
  return data;
};

export const fetchRecentActivities = async (mlsnum = null) => {
  const { data } = await APIService.get('/properties/recent-activities/', { params: mlsnum ? { mlsnum } : null });
  return data.activities || [];
};

export const fetchUpcomingOpenHouses = async (mlsnum = null) => {
  const { data } = await APIService.get('/properties/upcoming-open-houses/', { params: mlsnum ? { mlsnum } : null });
  return data.open_houses || [];
};

export const reserveOpenHouse = async (id) => {
  const { data } = await APIService.post(`/properties/attend-open-house/${id}/`);
  return data;
};

export const requestPropertyTour = async ({ mlsnum, phone, date }) => {
  const formData = new FormData();
  formData.append('phone', phone);
  formData.append('dates_and_times', date);

  const { data } = await APIService.post(`/properties/${mlsnum}/tour/`, formData);
  return data;
};

export const requestPropertyMoreInfo = async ({ mlsnum, phone, options }) => {
  const formData = new FormData();
  formData.append('phone', phone);
  options.forEach((value) => {
    formData.append('most_helpful', value);
  });

  const { data } = await APIService.post(`/properties/${mlsnum}/get-more-info/`, formData);
  return data;
};

export const requestPropertyFinancing = async (mlsnum) => {
  const { data } = await APIService.post(`/properties/${mlsnum}/financing/`);
  return data;
};

export const updateMapPolygons = async (bounds) => {
  const body = generateMapPolygonUpdateFormData(
    bounds.map((bound) =>
      bound.map((coord) => ({
        lat: () => coord.lat,
        lng: () => coord.lng,
      })),
    ),
  );
  await APIService.put('/properties/map-polygons/', body);
};

export const deleteMapPolygons = async () => {
  await APIService.delete('/properties/map-polygons/');
};
